import RasaLogo from "@images/rasa-logo.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { labelMain } from "../../../constants/classnames";
import { AZ, UT } from "../../../constants/usStates";

export function Intro() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleClick = (usState) => {
    const utmCode = searchParams.get("utm_campaign");
    const newState = {
      utm_code: utmCode,
      us_state: usState,
    };
    navigate("/register/intro-info", { state: newState });
  };

  return (
    <>
      <nav className="container relative mx-auto p-6">
        <div className="flex justify-center">
          <RasaLogo className="h-9" />
        </div>
      </nav>
      <section id="button">
        <div className="container mx-auto mb-16 mt-10 flex flex-col items-center px-4">
          <h2 className={labelMain}>select your state</h2>
          <button
            onClick={() => handleClick(AZ)}
            type="button"
            className="mb-4 min-w-60 rounded-full bg-rasapink p-4 font-bold text-white hover:shadow-xl"
          >
            arizona
          </button>
          <button
            onClick={() => handleClick(UT)}
            type="button"
            className="mb-8 min-w-60 rounded-full bg-rasapink p-4 font-bold text-white hover:shadow-xl"
          >
            utah
          </button>
          <Link to="/login">
            <button
              type="button"
              className="min-w-60 rounded-full bg-white p-4 font-bold text-gray-900 shadow-sm ring-2 ring-inset ring-rasapink hover:shadow-xl"
            >
              login
            </button>
          </Link>
        </div>
      </section>
    </>
  );
}
